const DiallerPushLogTypes = {
  DIALLER_PUSH_LOG_FETCH_START: "dialler_push_log_fetch_start",
  DIALLER_PUSH_LOG_FETCH_SUCCESS: "dialler_push_log_fetch_success",
  DIALLER_PUSH_LOG_FETCH_FAILURE: "dialler_push_log_fetch_failure",
  DIALLER_PUSH_LOG_FETCH_RESET_START: "dialler_push_log_fetch_Reset_start",
  DIALLER_PUSH_LOG_FETCH_RESPONSE_CHANGED: "dialler_push_log_fetch_changed",
};
export default DiallerPushLogTypes;
